import { FeedInPowerDto } from '../api/dto'
import { FeedInPowerModel } from '../model'

const fromFeedInPowerDtoToModelTransformer = (dto: FeedInPowerDto): FeedInPowerModel => ({
  installedPvPower: dto.installedPeakPower ?? 0,
  connectedPower: dto.connectedPower ?? 0,
  powerReduction: dto.derateAtPercentValue ?? 0,
  powerReductionRelatedTo: dto.derateAtConnectedPower ? false : true, // this is to display the correct value in frontend
  backupCurrent: dto.maxFusePower ?? 0,
})

export default fromFeedInPowerDtoToModelTransformer
